import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FaqArticle} from '../model/faq-article';
import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class FaqService extends CommonService<FaqArticle> {
  constructor(http: HttpClient) {
    super(http, '/faq');
  }
}
